<template>
  <Component
    v-if="url && componentIs && (file || finalMimeType === 'application/pdf')"
    v-bind="componentProps"
    :is="componentIs"
    class="h-full w-full"
  />
</template>

<script setup>
import {computed, defineAsyncComponent} from "vue";

const props = defineProps({
  file: {
    type: Object,
    required: false,
  },
  url: {
    type: String,
    required: true,
  },
  mimeType: {
    type: String,
    required: false,
  },
});

// Browser detection
const isChrome = computed(() => {
  return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
});

const docxPreview = defineAsyncComponent({
  loader: () => import("./PreviewDocx.vue"),
});

const txtPreview = defineAsyncComponent({
  loader: () => import("./PreviewTxt.vue"),
});

const notSupportedPreview = defineAsyncComponent({
  loader: () => import("./NotSupportedPreview.vue"),
});

const finalMimeType = computed(() => {
  if (props.file) return props.file.type;
  return props.mimeType;
});

const componentIs = computed(() => {
  switch (finalMimeType.value) {
  case "application/pdf":
    return isChrome.value ? "object" : "embed";
  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    return docxPreview;
  case "text/plain":
    return txtPreview;
  default:
    return notSupportedPreview;
  }
});

const componentProps = computed(() => {
  switch (finalMimeType.value) {
  case "application/pdf":
    if (isChrome.value) {
      // Chrome - use object
      return {
        data: props.url,
        type: "application/pdf",
        width: "100%",
        height: "100%",
        title: "Document Preview",
      };
    } else {
      // Other browsers - use embed
      return {
        src: props.url,
        type: "application/pdf",
        width: "100%",
        height: "100%",
      };
    }
  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
  case "text/plain":
    return {
      src: props.file,
    };
  default:
    return {};
  }
});
</script>
